<div>
  @switch (searchType()) {
    @case ('list') {
      <div class="text-center">
        @if (theme() === 'light') {
          <img
            src="/images/empty-state/empty-list.svg"
            class=" {{ imageClass() }} object-fit-cover image"
            alt="Empty List Image" />
        } @else {
          <img
            src="/images/empty-state/empty-list-dark-mode.svg"
            class=" {{ imageClass() }} object-fit-cover image"
            alt="Empty List Image" />
        }
        <p i18n class=" fs-l-medium {{ messageClass() }}">
          <b class="fw-bold"
            >The list is currently empty
            @if (searchTerm()) {
              for "{{ searchTerm() }}"
            }
            .</b
          >
          <br />
          Start adding items to fill it up!
        </p>
      </div>
    }
    @case ('merchant') {
      <div class="text-center">
        @if (theme() === 'light') {
          <img
            src="/images/empty-state/market-empty.svg"
            class=" {{ imageClass() }} object-fit-cover image"
            alt="Empty Merchant Search Image" />
        } @else {
          <img
            src="/images/empty-state/empty-market.svg"
            class=" {{ imageClass() }} object-fit-cover image"
            alt="Empty Merchant Search Image" />
        }

        <p i18n class="fs-l-medium {{ messageClass() }}">
          <b class="fw-bold"
            >Oops! We couldn't find anything
            @if (searchTerm()) {
              for "{{ searchTerm() }}"
            }
            .</b
          ><br />
          Try a different search term or browse by category.
        </p>
      </div>
    }
    @case ('product') {
      <div class="text-center">
        @if (theme() === 'light') {
          <img
            src="/images/empty-state/product.svg"
            class=" {{ imageClass() }} object-fit-cover image"
            alt="Empty Product Search Image" />
        } @else {
          <img
            src="/images/empty-state/product-dark-mode.svg"
            class=" {{ imageClass() }} object-fit-cover image"
            alt="Empty Product Search Image" />
        }
        <p i18n class="fs-l-medium {{ messageClass() }}">
          <b class="fw-bold"
            >Oops! We couldn't find anything
            @if (searchTerm()) {
              for "{{ searchTerm() }}"
            }
            .</b
          ><br />
          Try a different search term or browse by category.
        </p>
      </div>
    }
    @case ('other') {
      <div class="text-center">
        @if (theme() === 'light') {
          <img
            src="/images/empty-state/search-empty.svg"
            class=" {{ imageClass() }} object-fit-cover image"
            alt="Empty Global Search Image" />
        } @else {
          <img
            src="/images/empty-state/empty-search.svg"
            class=" {{ imageClass() }} object-fit-cover image"
            alt="Empty Global Search Image" />
        }
        <p i18n class="fs-l-medium {{ messageClass() }}">
          <b class="fw-bold"
            >Oops! We couldn't find anything
            @if (searchTerm()) {
              for "{{ searchTerm() }}"
            }
            .</b
          ><br />
          Try a different search term or browse by category.
        </p>
      </div>
    }
    @case ('service') {
      <div class="text-center">
        @if (theme() === 'light') {
          <img
            src="/images/empty-state/service-empty.svg"
            class=" {{ imageClass() }} object-fit-cover image"
            alt="Empty Service Search Image" />
        } @else {
          <img
            src="/images/empty-state/empty-service.svg"
            class=" {{ imageClass() }} object-fit-cover image"
            alt="Empty Service Search Image" />
        }
        <p i18n class=" fs-small {{ messageClass() }}">
          This service is not available yet, please try again later
        </p>
      </div>
    }
    @case ('permission') {
      <div class="text-center">
        <p i18n class="{{ messageClass() }}">
          Specific permissions are required to access this feature,<br />
          Thank you for your understanding.
        </p>
        @if (theme() === 'light') {
          <img
            src="/images/empty-state/empty-state.svg"
            class=" {{ imageClass() }} object-fit-cover image"
            alt="Empty Service Search Image" />
        } @else {
          <img
            src="/images/empty-state/empty-state2.svg"
            class=" {{ imageClass() }} object-fit-cover image"
            alt="Empty Service Search Image" />
        }
      </div>
    }
  }
</div>
